module.exports = __webpack_public_path__ + "media/ApplicantSummaryWeb.12eb872f.png";